import ListPagination from '../auto/stores/ListPagination';

(function () {
  let store = {
    ListPagination,
  };
  window.store = Object.assign(window.store || {}, {});
  Object.keys(store).forEach(c => (window.store[c] = store[c]()));
})();
